import { useMutation } from '@tanstack/react-query';
import { callPublicAPI } from '../utils/api';
import { AvailableSoon } from '../types/types';

export const useRemindMe = (
  offerId: string,
  {
    onSuccess
  }: {
    onSuccess?: (data: AvailableSoon) => void;
  }
) => {
  return useMutation({
    mutationFn: async () => {
      const response = await callPublicAPI<AvailableSoon>('POST', '/user-notifications', null, {
        adId: offerId,
        channel: 'mail'
      });
      return response.data;
    },
    onSuccess
  });
};
